<template>
    <v-card color="white">
    <v-row>
      <v-col cols="12">
        <b class="help-step" style="cursor:help;" @click="show_help($t('scientific-content.text'), $t('scientific-content.help'))">
          {{$t('scientific-content.text')}}
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                style="cursor:help;"
              >
                <v-icon color="grey lighten-1">mdi-help-circle</v-icon>
              </v-btn>
            </template>
            <span v-html="$t('scientific-content.help')"></span>
            <!-- <span v-html="">{{$t('scientific-content.help')}}</span> -->
          </v-tooltip>
        </b>

        <div class="input-container input-name">
          <v-textarea
            v-model="currentScientificContent"
            outlined
            :error="errorStrategy"
            :rules="[rules.required]"
            @input="currentScientificContent.length !== 0 ? errorStrategy = false : errorStrategy = true"
            type="text"
            counter="3000"
            maxLength="3000"
          ></v-textarea>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <b class="help-step" style="cursor:help;" @click="show_help($t('scientificBackground.text'), $t('scientificBackground.help'))">
          {{$t('scientificBackground.text')}}
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                style="cursor:help;"
              >
                <v-icon color="grey lighten-1">mdi-help-circle</v-icon>
              </v-btn>
            </template>
            <span v-html="$t('scientificBackground.help')"></span>
          </v-tooltip>
        </b>

        <div class="input-container input-name">
          <v-textarea
            v-model="currentScientificGroundWork"
            :value="backgrounds"
            outlined
            :error="errorScientificGroundWork"
            :rules="[rules.required]"
            @input="currentScientificGroundWork.length !== 0 ? errorScientificGroundWork = false : errorScientificGroundWork = true"
            type="text"
            counter="3000"
            maxLength="3000"
          ></v-textarea>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <b class="help-step" style="cursor:help;" @click="show_help($t('expectedResult.text'), $t('expectedResult.help'))">
          {{$t('expectedResult.text')}}
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                style="cursor:help;"
              >
                <v-icon color="grey lighten-1">mdi-help-circle</v-icon>
              </v-btn>
            </template>
            <span v-html="$t('expectedResult.help')"></span>
          </v-tooltip>
        </b>

        <div class="input-container input-name">
          <v-textarea
            no-resize
            v-model="currentExpectedResults"
            outlined
            :error="errorExpectedResults"
            :rules="[rules.required]"
            @input="currentExpectedResults.length !== 0 ? errorExpectedResults = false : errorExpectedResults = true"
            type="text"
            counter="3000"
            maxLength="3000"
            height="195" >
          </v-textarea>
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>

import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'InfoStep',
  props: [
    'problem_formulation',
    'backgrounds', 'expected_results',
    ],

  data() {
    return {
      errorStrategy: false,
      errorExpectedResults: false,
      errorScientificGroundWork: false,
      currentScientificContent: this.problem_formulation,
      currentScientificGroundWork: this.backgrounds,
      currentExpectedResults: this.expected_results,
      rules: {
        required: (value) => (value === null || value.length === 0) ? this.$t('required') : true,
      },
    };
  },

  computed: {
    ...mapGetters([
      'GETTERS_NEW_PROPOSAL_STEPPER_NEED_CHECK',
    ]),
  },

  watch: {
    'GETTERS_NEW_PROPOSAL_STEPPER_NEED_CHECK.step2'(val){
      if(val){
        var status = this.validateInputs()

        this.NEW_PROPOSAL_UPDATE_STEPPER_CHECK_STATUS({name: 'step2', value: status})
        this.NEW_PROPOSAL_UPDATE_STEPPER_NEED_CHECK({name: 'step2', value: false})
      }
    },

    async currentScientificGroundWork(val) {
      this.UPDATE_QUIZE({background: val});
    },
    async currentExpectedResults(val) {
      this.UPDATE_QUIZE({expected_results: val});
    },
    async currentScientificContent(val) {
      this.UPDATE_QUIZE({problem_formulation: val});
    },

  },

  methods: {
    ...mapMutations([
      'UPDATE_QUIZE',
      'UPDATE_HELPER_DIALOG',
      'NEW_PROPOSAL_UPDATE_STEPPER_CHECK_STATUS',
      'NEW_PROPOSAL_UPDATE_STEPPER_NEED_CHECK',
    ]),

    show_help(header = '', text = ''){
      this.UPDATE_HELPER_DIALOG({
        'show' : true,
        'helper_data': {
          'header': header,
          'text': text,
        }
      })
    },

    validateInputs() {
      var status = true
      if (this.currentScientificContent === null || this.currentScientificContent.length === 0){
        this.errorStrategy = true
        status = false
      }
      if (this.currentScientificGroundWork === null || this.currentScientificGroundWork.length === 0){
        this.errorScientificGroundWork = true
        status = false
      }
      if (this.currentExpectedResults === null || this.currentExpectedResults.length === 0){
        this.errorExpectedResults = true
        status = false
      }

      return status
    },
  },
};

</script>
<style scoped>

  .input-container {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
  .input-container .v-input__slot 
  .mb-12.wrapper.v-card.v-sheet.theme--light.white{
    box-shadow: none;
  }

  .form-container {
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    max-width: 700px;
    width: 100%;
  }
  h4{
    color: #949494;
    letter-spacing: -0.015em;
    font-style: normal;
    font-weight: 500;
  }
  .name-block{
    padding-top:30px;
  }
  .help-step {
    margin: 0 auto 0 0;
    color: #949494;
  }
</style>
